import Model from './Model'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default class Comment extends Model {
  resource () {
    return 'report/comments'
  }

  get reportedAt () {
    return dayjs.utc(this.reported_at).format('MMM DD, YYYY hh:mm A')
  }
}
